export default {"src":"/_next/static/media/our-principle-icon4.826a314a.svg","height":54,"width":54};